import { defineMessages } from 'react-intl';

export const messages: {
	privateLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	privateTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	restrictedLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	restrictedTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	restrictedLabel: {
		id: 'search-page.results.restricted-result-label',
		defaultMessage: 'Restricted',
		description:
			'The text displayed in the result to tell the user that the result is visible to a group of people.',
	},
	restrictedTooltip: {
		id: 'search-page.results.restricted-result-tooltip',
		defaultMessage: 'Only visible to specific people',
		description:
			'The text displayed in the tooltip when the user hovers over the restricted label.',
	},
	privateLabel: {
		id: 'search-page.results.private-result-label',
		defaultMessage: 'Private',
		description:
			'The text displayed in the result to tell the user that the result is visible to only themselves.',
	},
	privateTooltip: {
		id: 'search-page.results.private-result-tooltip',
		defaultMessage: 'Only visible to you',
		description: 'The text displayed in the tooltip when the user hovers over the private label.',
	},
});
